import { Brain } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border/50 py-6 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="flex items-center space-x-3 mb-3 md:mb-0">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
              <Brain className="w-4 h-4 text-white" />
            </div>
            <span className="text-base font-bold text-foreground">Архітектор Майбутнього</span>
          </div>
          <div className="text-center md:text-right">
            <p className="text-sm text-muted-foreground">© 2026. Всі права захищені.</p>
            <p className="text-xs text-muted-foreground/70 mt-1">Автор ідеї: Євген Міхальов</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
